import React, { useState, forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { Eye, EyeOff } from 'lucide-react';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  label,
  error,
  helperText,
  ...props
}, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  return <div className="w-full space-y-1.5" data-id="element-372">
        {label && <label className="text-sm font-medium text-neutral-700 block" data-id="element-373">
            {label}
          </label>}
        <div className="relative" data-id="element-374">
          <input type={isPassword ? showPassword ? 'text' : 'password' : type} className={cn('flex h-9 w-full rounded-md border bg-white px-3 py-2 text-sm text-neutral-900 placeholder:text-neutral-400 transition-all duration-150', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary focus-visible:ring-offset-0', 'disabled:cursor-not-allowed disabled:opacity-40', error ? 'border-error focus-visible:ring-error' : 'border-neutral-300 focus-visible:border-atios-primary', className)} ref={ref} {...props} data-id="element-375" />
          {isPassword && <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-neutral-600 transition-colors" data-id="element-376">
              {showPassword ? <EyeOff className="h-4 w-4" data-id="element-377" /> : <Eye className="h-4 w-4" data-id="element-378" />}
            </button>}
        </div>
        {error && <p className="text-xs text-error" data-id="element-379">{error}</p>}
        {helperText && !error && <p className="text-xs text-neutral-500" data-id="element-380">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';
export { Input };